import { gql } from 'graphql-request';

export const GET_TALENT_PROFILES = gql`
  query ($search: String) {
    profiles(search: $search) {
      id
      is_group_profile
      group_name
      primary_medium_attachment {
        attachment
      }
    }
  }
`;

export const GET_TALENT_PROFILE_IDS = gql`
  query ($search: String) {
    profiles(search: $search) {
      id
      representation_type
    }
  }
`;

export const GET_PROFILES = gql`
  query ($search: String) {
    profiles(search: $search) {
      use_own_talent_permissions
      talent_permissions
      id
      representation_type
      primary
      images {
        id
        attachment
        modified_attachment
      }
      videos {
        id
        attachment
        modified_attachment
      }
      audios {
        id
        attachment
        modified_attachment
      }
      documents {
        id
        attachment
        modified_attachment
      }
      primary_medium_attachment {
        primary
        attachment
        modified_attachment
      }
      talent {
        stage_name
        away_period {
          id
          title
          start_datetime
          end_datetime
          timezone
        }
      }
      agency {
        name
        full_name
        country
        state
        contact_number
        talent_permissions
      }
      casting_private
      completeness
      division {
        id
        name
      }
      casting_company {
        name
        full_name
        contact_number
      }
    }
  }
`;

export const LINKS_PROFILES = gql`
  query ($search: String) {
    profiles(search: $search) {
      id
      is_published
      is_published_by_agency
      primary_link
      shareable_info
      representation_type
      agency {
        full_name
        country
        contact_number
        primary_address {
          country_code
        }
        slug
        contact_country_code
      }
      casting_private
      division {
        id
        name
      }
      casting_company {
        name
        full_name
        contact_number
      }
      primary_medium_attachment {
        modified_attachment
      }
    }
  }
`;

export const GET_PROFILE = gql`
  query ($id: ID!) {
    profile(id: $id) {
      id
      profile_type
      primary
      representation_type
      completeness
      talent {
        stage_name
        slug
        other_phone_numbers
        email
      }
      talent_permissions
      use_own_talent_permissions
      agency {
        talent_permissions
        name
        full_name
        email
        contact_number
        slug
        primary_address {
          country_code
        }
        country
      }
      division {
        name
        id
      }
      resume
      primary_medium_attachment {
        attachment
        modified_attachment
      }
    }
  }
`;

// Public Profile

export const GET_PUBLIC_PROFILE = gql`
  query PublicProfile(
    $countryCode: String!
    $talentSlug: String!
    $companySlug: String!
    $divisionId: String
    $token: String
  ) {
    public_profile(
      countryCode: $countryCode
      talentSlug: $talentSlug
      companySlug: $companySlug
      divisionId: $divisionId
      token: $token
    ) {
      id
      representation_type
      shareable_info
      composite_card
      talent {
        general
        email
        first_name
        last_name
        contact_no
        country
        country_code
        statistics
        sag_status
        social_media_accounts
        biography
        skills
        stage_name
        other_phone_numbers
        gender
        unions
      }
      division {
        name
        email
        id
        contact_number
      }
      agency {
        full_name
        name
        email
        company_type
        contact_first_name
        contact_last_name
        contact_number
        country
        logo
        primary_address {
          country_code
        }
        contact_country_code
      }
      representatives {
        id
        contact_country_code
        contact_number
        position_name
        user {
          contact_no
          first_name
          last_name
          id
          email
          country_code
        }
      }
      resume
      resume_category_ids
      medium_attachments {
        sort
        medium {
          id
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
          tag_list
          modified_attachment_url
          attachment_url
          cropped_attachment_url
        }
      }
      primary_medium_attachment {
        primary
        medium_id
        mediumable_id
        mediumable_type
        attachment
        modified_attachment
        medium {
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
        }
      }
      resume_hide_years
      use_profile_sizes
      statistics
    }
  }
`;

export const GET_SHAREABLE_PROFILE = gql`
  query ($id: ID!) {
    profile(id: $id) {
      id
      representation_type
      shareable_info
      composite_card
      talent {
        general
        email
        first_name
        last_name
        contact_no
        country
        country_code
        statistics
        sag_status
        social_media_accounts
        biography
        skills
        stage_name
        other_phone_numbers
        gender
        unions
      }
      division {
        name
        email
        id
        contact_number
      }
      agency {
        full_name
        name
        email
        company_type
        contact_first_name
        contact_last_name
        contact_number
        country
        logo
        primary_address {
          country_code
        }
        contact_country_code
      }
      representatives {
        id
        contact_country_code
        contact_number
        position_name
        user {
          contact_no
          first_name
          last_name
          id
          email
          country_code
        }
      }
      resume
      resume_category_ids
      medium_attachments {
        sort
        medium {
          id
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
          tag_list
          modified_attachment_url
          attachment_url
          cropped_attachment_url
        }
      }
      primary_medium_attachment {
        primary
        medium_id
        mediumable_id
        mediumable_type
        attachment
        modified_attachment
        medium {
          file_type
          file_name
          file_size
          file_width
          file_height
          visible
        }
      }
      resume_hide_years
      use_profile_sizes
      statistics
    }
  }
`;
